﻿<template>
    <q-img :src="qrCodeUrl"
           spinner-color="white"
           style="height: 200px;width: 200px;">
    </q-img>
</template>

<script>
    export default {
        props: {
            dataSource: {
                type: String,
                default: null,
            },
        },

        computed: {
            qrCodeUrl: function () {
                if (this.dataSource != null)
                    return 'https://api.qrserver.com/v1/create-qr-code/?size=200x200&data=' + encodeURIComponent(this.dataSource);
                return '//:0';
            }
        },
    };
</script>